// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2LnEI","inputWrap":"styles_inputWrap__3miZj","input":"styles_input__OqpFS"};